module.exports = __webpack_public_path__ + "img/icon_del.323c2479.png";